import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { ISSObject } from '../interfaces';

export type IGetSSObjectsRepoResponse = IRepoResponse<200, ISSObject[]> | IRepoResponse<400 | 500, string>;

export type IGetSSObjectsRepo = IRepo<[], IGetSSObjectsRepoResponse>;

export const GetSSObjectsRepoType = Symbol.for('GetSSObjectsRepo');

@bind(GetSSObjectsRepoType)
export class GetSSObjectsRepo implements IGetSSObjectsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute() {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/selects/objects') });

      if (result.status === 200) {
        const data: ISSObject[] = result.data.data;
        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
